'use es6';

import PropTypes from 'prop-types';
import { Map as ImmutableMap } from 'immutable';
import { InlineLabels } from 'reporting-ui-components/components/inlineLabels/InlineLabels';
import EmptyState from './EmptyState';
import RevenueUpdateInfo from './RevenueUpdateInfo';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function CampaignRevenueAttributionLimitedAccessEmptyState({
  asExport,
  config,
  isLimitedAccessRangeType,
  isLimitedAccessStartDate
}) {
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [!asExport && /*#__PURE__*/_jsx(InlineLabels
    // https://git.hubteam.com/HubSpot/reporting/blob/82a9b6e0e62cd9026fa790757c29292b29886534/reporting-ui-components/static-2.58232/js/components/inlineLabels/InlineLabels.tsx
    , {
      config: config,
      isMobile: false
    }), /*#__PURE__*/_jsx(RevenueUpdateInfo, {}), /*#__PURE__*/_jsx(EmptyState, {
      translationKey: isLimitedAccessStartDate && !isLimitedAccessRangeType ? 'noDataProLimitedStartDate' : 'noDataPro',
      hasRevenueAttributionLimitedAccess: true
    })]
  });
}
CampaignRevenueAttributionLimitedAccessEmptyState.propTypes = {
  asExport: PropTypes.bool.isRequired,
  config: PropTypes.instanceOf(ImmutableMap).isRequired,
  isLimitedAccessRangeType: PropTypes.bool.isRequired,
  isLimitedAccessStartDate: PropTypes.bool.isRequired
};